import type { SerializedError } from "@reduxjs/toolkit";
import type { BaseQueryFn, EndpointBuilder } from "@reduxjs/toolkit/query";

import type { TAGS } from "./common/tags";

export type TagTypes = typeof TAGS.PAYMENT_METHODS;
export type ReducerPath = "paymentApi";

export type EmptyBaseQuery = BaseQueryFn<unknown, unknown, SerializedError>;

export type PaymentApiBuilder = EndpointBuilder<EmptyBaseQuery, TagTypes, ReducerPath>;
